import React, { FunctionComponent } from 'react';
import { FieldError } from '@spike/model';
import { NumberField } from '../NumberField';
import clsx from 'clsx';
import styles from './PriceField.module.scss';

export interface PriceFieldProps {
    id?: string;
    name?: string;
    label?: string | JSX.Element;
    placeholder?: string;
    value: number | undefined;
    required?: boolean;
    errors?: Array<FieldError>;
    className?: string;
    autoFocus?: boolean;
    autoComplete?: 'off' | 'on';
    disabled?: boolean;
    scale?: number;
    precision?: number;
    information?: string;
    max?: number;
    default?: string;
    onEnterPressed?: () => void;
    onBlur?: () => void;
    onChange: (value: number | undefined, name?: any) => void;
    onFocus?: () => void;
    onKeyPress?: (event: any) => void;
}

export const PriceField: FunctionComponent<PriceFieldProps> = props => {
    const dollarIcon = <span className={styles.dollarSign}>$</span>;

    return (
        <NumberField
            {...props}
            startIcon={dollarIcon}
            className={clsx(styles.priceField, props.className)}
        />
    );
};

export default PriceField;
